import { Operator } from "../types/operator";

/** Normalize operator DTOs from API (camelCase or PascalCase) for form Selects. */
export function normalizeOperatorsFromApi(items: unknown): Operator[] {
  if (!Array.isArray(items)) return [];

  return items
    .map((raw): Operator | null => {
      const op = raw as Record<string, unknown>;
      const id = String(op.id ?? op.Id ?? "").trim();
      if (!id) return null;

      return {
        id: id.toLowerCase(),
        tenantId: String(op.tenantId ?? op.TenantId ?? ""),
        name: String(op.name ?? op.Name ?? ""),
        isActive: Boolean(op.isActive ?? op.IsActive ?? true),
        createdBy: String(op.createdBy ?? op.CreatedBy ?? ""),
        createdAt: String(op.createdAt ?? op.CreatedAt ?? ""),
        updatedAt: (op.updatedAt ?? op.UpdatedAt ?? null) as string | null,
      };
    })
    .filter((op): op is Operator => op !== null);
}

export function findOperatorName(
  operators: Operator[],
  operatorId: unknown,
  fallbackName?: string | null
): string {
  const id = String(operatorId ?? "").trim().toLowerCase();
  if (id) {
    const match = operators.find((op) => op.id.trim().toLowerCase() === id);
    if (match?.name?.trim()) return match.name.trim();
  }
  if (fallbackName?.trim()) return fallbackName.trim();
  return "";
}
